import React from 'react';

import { Box, Typography } from '@mui/material';
import Button from 'components/V2/Button';
import PropTypes from 'prop-types';

import styles from './tourTooltip.module.css';

const TITLE_ID = 'sidebar-tour-title';
const BODY_ID = 'sidebar-tour-body';

function TourTooltip({
    index,
    size,
    step,
    isLastStep,
    backProps,
    primaryProps,
    skipProps,
    tooltipProps,
}) {
    return (
        <Box
            {...tooltipProps}
            aria-labelledby={TITLE_ID}
            aria-describedby={BODY_ID}
            className={styles.tooltip}
        >
            <Typography variant="inherit" className={styles.progress}>
                {index + 1} of {size}
            </Typography>
            <Typography variant="inherit" component="h2" id={TITLE_ID} className={styles.title}>
                {step.title}
            </Typography>
            <Typography variant="inherit" id={BODY_ID} className={styles.body}>
                {step.content}
            </Typography>
            <Box className={styles.footer}>
                {!isLastStep && (
                    <Button intent="text" size="sm" {...skipProps} className={styles.skip}>
                        Skip tour
                    </Button>
                )}
                <Box className={styles.actions}>
                    {index > 0 && (
                        <Button intent="secondary" size="sm" {...backProps}>
                            Back
                        </Button>
                    )}
                    <Button intent="primary" size="sm" {...primaryProps}>
                        {isLastStep ? 'Done' : 'Next'}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

TourTooltip.propTypes = {
    index: PropTypes.number,
    size: PropTypes.number,
    step: PropTypes.object,
    isLastStep: PropTypes.bool,
    backProps: PropTypes.object,
    primaryProps: PropTypes.object,
    skipProps: PropTypes.object,
    tooltipProps: PropTypes.object,
};

export default TourTooltip;
